export default "__VITE_ASSET__1aoCy$ZB__"